import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonAction, ButtonType } from '../action-button/constants';
import { IconNames } from '../../common/constants/icon-names';

@Component({
  selector: 'ui-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoPageComponent {
  @Input() title: string;
  @Input() description: string;
  @Output() buttonClick = new EventEmitter<void>();

  buttonAction = ButtonAction;
  buttonType = ButtonType;
  iconNames = IconNames;
}
